import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';

export function RecommendationPromptDialog({ target, value, onChange, onClose, onSave, disabled, error }: {
  target: { label: string; mode: 'promoted' | 'excluded' } | null; value: string; onChange(value: string): void; onClose(): void; onSave(): void; disabled: boolean; error: string;
}) {
  return <Dialog open={target !== null} onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent className='w-[400px] bg-white p-5'>
      <DialogTitle>{target?.label}</DialogTitle>
      <DialogDescription className='text-xs text-gray-800'>Tell us when to {target?.mode === 'excluded' ? 'exclude' : 'recommend'} this item.</DialogDescription>
      <label htmlFor='recommendation-prompt' className='text-xs text-ink'>When to {target?.mode === 'excluded' ? 'exclude' : 'recommend'} (optional)</label>
      <Textarea id='recommendation-prompt' maxLength={10000} value={value} onChange={(event) => onChange(event.target.value)} disabled={disabled} placeholder='Type something…' />
      {error && <p role='alert' className='text-xs text-red-600'>{error}</p>}
      <DialogFooter><Button variant='ghost' onClick={onClose}>Cancel</Button><Button aria-label='Save prompt' disabled={disabled} onClick={onSave}>Save</Button></DialogFooter>
    </DialogContent>
  </Dialog>;
}
